// Texas Tech University's undergraduate majors (#2652). Read on 2026-10-01
// from Texas Tech's official program finder (www.ttu.edu/programs, the
// bachelor's entries of the programs.json file the page loads), on-campus
// bachelor's programs only, grouped by the college the finder names.
// Departures: the 2026-2027 catalog (catalog.ttu.edu) answered curl and
// WebFetch with an empty 202 bot challenge, so the finder is the official
// list used here, and it may not list every catalog major. Left out: the
// online-only bachelor's programs, the pre-professional advising tracks
// (Pre-Dental, Pre-Medicine, Pre-Nursing, Pre-Physical Therapy) and
// Pre-Veterinary, which the finder lists as Animal Science with a science
// concentration. Degrees are the finder's own wording ("Bachelor of Arts and
// Science" and "Bachelor of Arts and Fine Arts" mean either degree). College
// names use "and" for the finder's ampersand. The KB's majors list was the
// starting point; the official list wins.
const majors = {
    "slug": "texas-tech-university",
    "read": "2026-10-01",
    "intro": "Every on-campus bachelor's program in Texas Tech's official program finder, grouped by the college that offers it, with the degree it leads to. Minors, certificates, online-only and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Arts & Sciences Multidisciplinary Studies",
                    "degree": "Bachelor of Science and General Studies"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Arts and Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts and Science"
                },
                {
                    "name": "Criminology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts and Science"
                },
                {
                    "name": "Economics & Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Forensic Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geography & the Environment",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geosciences",
                    "degree": "Bachelor of Arts and Science"
                },
                {
                    "name": "Global Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "International Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Languages & Cultures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts and Science"
                },
                {
                    "name": "Mathematics / Computer Science (Dual)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychological Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Renewable Energy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sport Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Writing, Design, and Technical Communication",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Education",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Apparel Design & Manufacturing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied Personal Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Counseling & Addiction Recovery Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Event Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Family & Consumer Sciences Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Sciences / BSN in Nursing (Dual)",
                    "degree": "Bachelor of Science / BSN"
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Interior Design"
                },
                {
                    "name": "Nutrition",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Nutritional Sciences & Dietetics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Personal Financial Planning",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Restaurant, Hotel & Institutional Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Retail Management",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Media and Communication",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Creative Media Industries",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Relations & Strategic Communication Management",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Davis College of Agricultural Sciences and Natural Resources",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural & Applied Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural & Applied Economics / General Business (Dual)",
                    "degree": "Bachelor of Science / Bachelor of Business Administration"
                },
                {
                    "name": "Agricultural Communications",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Animal Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Conservation Law Enforcement",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Food Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "Bachelor of Landscape Architecture"
                },
                {
                    "name": "Natural Resources Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Plant & Soil Science",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Edward E. Whitacre Jr. College of Engineering",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Environmental Engineering"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Huckabee College of Architecture",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Architecture / Civil Engineering (Dual)",
                    "degree": "Bachelor of Science / Bachelor of Science"
                },
                {
                    "name": "Architecture / General Business (Dual)",
                    "degree": "Bachelor of Science / Bachelor of Business Administration"
                }
            ]
        },
        {
            "name": "J.T. and Margaret Talkington College of Visual and Performing Arts",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts and Fine Arts"
                },
                {
                    "name": "Arts Media & Technology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts and Fine Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts and Applied Arts"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "Bachelor of Arts and Fine Arts"
                }
            ]
        },
        {
            "name": "Jerry S. Rawls College of Business",
            "source": {
                "label": "Texas Tech University, Programs (bachelor's)",
                "url": "https://www.ttu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Energy Commerce",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Information Technology",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "Bachelor of Business Administration"
                }
            ]
        }
    ]
};

export default majors;
